import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithReauth } from "@states/auth/auth.api";
import { PUSH_NOTIFICATION } from "@utils/constants/others/push-notification.constants";

export const pushNotificationApi = createApi({
  reducerPath: "pushNotificationApi",
  tagTypes: ["PushNotification"],
  baseQuery: baseQueryWithReauth,
  endpoints: (builder) => ({
    getAllPushNotifications: builder.query<
      [],
      {
        page?: number;
        limit?: number;
        search?: string;
        status?: string | number;
        send_status?: string;
        schedule_type?: string;
      }
    >({
      query: ({
        page = 1,
        limit = 10,
        search,
        status,
        send_status,
        schedule_type,
      }) => {
        const queryParams = {
          url: PUSH_NOTIFICATION.GET_ALL,
          params: { page, limit },
        } as any;

        if (search) {
          queryParams.params.search = search;
        }

        if (status !== undefined && status !== "") {
          queryParams.params.status = status;
        }

        if (send_status) {
          queryParams.params.send_status = send_status;
        }

        if (schedule_type) {
          queryParams.params.schedule_type = schedule_type;
        }

        return queryParams;
      },
      providesTags: ["PushNotification"],
    }),
    createPushNotification: builder.mutation({
      query: (body) => ({
        url: PUSH_NOTIFICATION.CREATE,
        method: "POST",
        body,
      }),
      invalidatesTags: ["PushNotification"],
    }),
    deletePushNotification: builder.mutation({
      query: ({ id, reason }) => ({
        url: `${PUSH_NOTIFICATION.DELETE}${id}`,
        method: "DELETE",
        body: { reason: reason || null },
      }),
      invalidatesTags: ["PushNotification"],
    }),
    sendPushNotification: builder.mutation({
      query: (id) => ({
        url: `${PUSH_NOTIFICATION.SEND}${id}`,
        method: "POST",
      }),
      invalidatesTags: ["PushNotification"],
    }),
  }),
  keepUnusedDataFor: 0,
});

export const {
  useGetAllPushNotificationsQuery,
  useCreatePushNotificationMutation,
  useDeletePushNotificationMutation,
  useSendPushNotificationMutation,
} = pushNotificationApi;
